import { FC, useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { endpointPrincipal } from "../../../api/endPoints/endpointPrincipal/endpointPrincipal";

interface OpcaoCodSistema {
  codigo: string;
  descricao: string;
}

interface SelectCodSistemaProps {
  // Tabela do código do sistema (ex.: "FUNCOES", "GRUPOS")
  tabela: string;
  name: string;
  control: Control<any>;
  label: string;
  disabled?: boolean;
  required?: boolean;
}

// Select que carrega as opções de uma tabela do Código do Sistema (mesmo padrão do XC WMS)
const SelectCodSistema: FC<SelectCodSistemaProps> = ({
  tabela,
  name,
  control,
  label,
  disabled = false,
  required = false,
}) => {
  const [opcoes, setOpcoes] = useState<OpcaoCodSistema[]>([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    let ativo = true;

    const carregarOpcoes = async () => {
      setCarregando(true);
      try {
        const { data } = await endpointPrincipal.get(
          `codigosistema/detalhes/${tabela}`
        );
        if (ativo) setOpcoes(Array.isArray(data) ? data : []);
      } catch (erro: any) {
        toast.error(
          `Falha ao carregar ${label}. Motivo: ${
            erro.response?.data?.message || erro.message
          }`
        );
      } finally {
        if (ativo) setCarregando(false);
      }
    };

    carregarOpcoes();
    return () => {
      ativo = false;
    };
  }, [tabela, label]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={{ required: required ? `${label} é obrigatório` : false }}
      render={({ field, fieldState }) => {
        const selecionada =
          opcoes.find(
            (opcao) => String(opcao.codigo) === String(field.value ?? "")
          ) || null;

        return (
          <Autocomplete
            options={opcoes}
            loading={carregando}
            disabled={disabled}
            value={selecionada}
            onChange={(_, novaOpcao) =>
              field.onChange(novaOpcao ? novaOpcao.codigo : "")
            }
            onBlur={field.onBlur}
            getOptionLabel={(opcao) => opcao.descricao || ""}
            isOptionEqualToValue={(opcao, valor) =>
              String(opcao.codigo) === String(valor.codigo)
            }
            noOptionsText="Nenhuma opção disponível"
            loadingText="Carregando..."
            renderInput={(params) => (
              <TextField
                {...params}
                inputRef={field.ref}
                label={label}
                size="small"
                fullWidth
                required={required}
                InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        );
      }}
    />
  );
};

export default SelectCodSistema;
